import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { CapricornService } from './capricorn.service';

angular.module('app-lite.capricorn', [])
  .service('capricornApi', downgradeInjectable(CapricornService));
